var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Socials/Facebook"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "M57.5999 32.1566C57.5999 17.9317 46.1384 6.40013 31.9999 6.40013C17.8614 6.40013 6.3999 17.9317 6.3999 32.1566C6.3999 45.0123 15.7614 55.6679 27.9999 57.6001V39.6018H21.4999V32.1566H27.9999V26.4821C27.9999 20.0269 31.8218 16.4612 37.6694 16.4612C40.4702 16.4612 43.3999 16.9643 43.3999 16.9643V23.3028H40.1718C36.9916 23.3028 35.9999 25.2882 35.9999 27.3251V32.1566H43.0999L41.9649 39.6018H35.9999V57.6001C48.2383 55.6679 57.5999 45.0123 57.5999 32.1566Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.520a9e4886888e05869b7fdfdfd87125.svg";
export { ForwardRef as ReactComponent };